enum EventTypes {
  ExternalEvent = "ExternalEvent",
}
export default EventTypes;
